<template>
  <div style="display: flex; align-items: center">
    <span style="margin-right: 10px"> {{ i18nJS.users.index.search }} </span>
    <!-- usare v-select2 con :selectConfig così non va bene -->
    <v-select2
      @input="selectRequirement()"
      :multiple="false"
      data-allow-clear="true"
      :data-placeholder="'Seleziona un elemento'"
      :data-ajax--url="url + '.json?business_unit_id=' + buId + '&view=report_template'"
      data-minimumInputLength="0"
      data-pageLimit="20"
      id="requirement_user_id"
    >
    </v-select2>
  </div>
</template>

<script>
import vSelect2 from '../../vSelect2';
import apiConnector from '@/epersonam/apiConnector';

export default {
  name: 'userRequirement',
  props: ['buId', 'index', 'params'],
  components: {
    vSelect2,
  },
  data() {
    return {
      isLoading: false,
      result: null,
      url: '/it/users',
    };
  },
  mounted() {},
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  methods: {
    selectRequirement() {
      const data_selected = $('#requirement_user_id').select2('data')[0];
      this.$emit('selected', { data_selected, index: this.index });
    },
  },
};
</script>

<style lang="scss" scoped></style>
